/** Read-only production prompt from an AI provider node (page widget `prompt_out`). */

export function AiProductionPromptPanel(props: { text: string }) {
  const { text } = props;
  if (!text.trim()) {
    return <div className="muted pageAiProductionPromptEmpty">No production prompt configured.</div>;
  }
  return (
    <textarea
      readOnly
      aria-label="Production prompt"
      value={text}
      className="pageAiProductionPrompt"
    />
  );
}
